import {
    ChatBase,
    ParamsType,
    OnChatDispResponse,
    OnSubmitLog,
    RCXLogger,
    OnGetChatLink,
    ChatLink,
    ChatLogStorage,
} from 'rcx_adapter';

import { BaseModule } from './BaseModule';
import { ModuleBaseOption } from '../interfaces/module';
import { mapLogInfo } from '../utils/mapData';
class DigitalLog extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onChatPresented(this.handleChatPresented.bind(this));
        this.mRCXAdapter!.onChatRejected(this.handleChatRejected.bind(this));
        this.mRCXAdapter!.onChatDispResponse(this.handleChatDispResponse.bind(this));
        this.mRCXAdapter!.onChatAccepted(this.handleChatAccepted.bind(this));
        this.mRCXAdapter!.onSubmitLog(this.handleSubmitLog.bind(this));
        this.mRCXAdapter!.onGetChatLink(this._handleGetChatLink.bind(this));
    }

    private _handleGetChatLink(data: OnGetChatLink) {
        const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
        return logAdapter.getCRMLink<ChatLink>(
            data.digital?.map((chat) => chat.uii!) || [],
            ChatLogStorage,
            'crmChatLog'
        );
    }

    private handleChatPresented(chat: ChatBase) {
        const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
        logAdapter.initStorageLog({
            params: chat,
            paramsType: ParamsType.CHAT,
            id: chat.uii || '',
        });
        this.mServiceNowAdapter!.showOpenFrame();
    }

    private handleChatRejected(chat: ChatBase) {
        const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
        logAdapter.removeStorageLog(ParamsType.CHAT, chat.uii);
    }

    private async handleChatDispResponse(data: OnChatDispResponse) {
        if (data) {
            const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
            await logAdapter.updateStorageLogAndContact({
                id: data.uii,
                paramsType: ParamsType.CHAT,
                rawData: {
                    notes: data.notes,
                    disposition: data.disposition,
                    summary: data.summary,
                    transcriptUrl: data.transcriptUrl,
                },
            });
            await logAdapter.saveLogToSN({
                callId: data.uii,
                paramsType: ParamsType.CHAT,
            });
            this.mRCXAdapter?.sendDispositionResult({
                success: true,
                data: { uii: data.uii },
            });
        }
    }

    private handleChatAccepted(chat: ChatBase) {
        if (chat) {
            const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
            logAdapter.updateStorageLogAndContact({
                id: chat.uii,
                paramsType: ParamsType.CHAT,
                rawData: { handleTime: Date.now() },
            });
        }
    }

    private async handleSubmitLog(payload: OnSubmitLog) {
        const logAdapter = this.mServiceNowAdapter!.getLogAdapter();
        if (payload && payload.type === ParamsType.CHAT) {
            if (payload.serviceNowLogInfo) {
                if (payload.uii) {
                    try {
                        await logAdapter.updateStorageLogAndContact({
                            id: payload.uii,
                            rawData: mapLogInfo(payload.serviceNowLogInfo),
                            paramsType: ParamsType.CHAT,
                        });
                    } catch (error) {
                        RCXLogger.getInstance().info('Workaround for the event out of order');
                    }
                }
                const data = payload.params as OnChatDispResponse;
                // On digital history submit log
                if (data && data.uii) {
                    await logAdapter.initStorageLog({
                        params: data,
                        paramsType: ParamsType.CHAT,
                        id: data.uii,
                    });
                    await logAdapter.updateStorageLogAndContact({
                        id: data.uii,
                        paramsType: ParamsType.CHAT,
                        rawData: {
                            notes: data.notes,
                            disposition: data.disposition,
                            summary: data.summary,
                            transcriptUrl: data.transcriptUrl,
                            ...mapLogInfo(payload.serviceNowLogInfo),
                        },
                    });
                    await logAdapter.saveLogToSN({
                        callId: data.uii,
                        paramsType: ParamsType.CHAT,
                    });
                }

                return {
                    success: true,
                };
            }
            return {
                success: false,
                error: { message: 'Wrong params' },
            };
        }
    }
}

export default new DigitalLog();
